import { fabric } from 'fabric'
import Shape from './CanvasObject'
import { setTargetActiveByEvent } from '../utils/setCanvas'

interface MousePosition {
    x: number
    y: number
}
class Drag extends Shape {
    pos = {} as MousePosition

    public constructor(canvas: fabric.Canvas) {
        super(canvas)
    }

    public onMouseUp() {
        this.disable()
    }

    public onMouseMove(event: fabric.IEvent) {
        // 松开鼠标后
        // 选中的对象有object:moving
        if (!this.isEnable() || this.canvas.getActiveObject()) return

        // 移动画布
        const { clientX, clientY } = event.e as MouseEvent
        const { x, y } = this.pos
        this.canvas.relativePan(new fabric.Point(clientX - x, clientY - y))
        this.pos = {
            x: clientX,
            y: clientY,
        }
    }

    public onMouseDown(event) {
        this.enable()

        this.pos = {
            x: event.e.clientX,
            y: event.e.clientY,
        }

        // 设置画布、框的选中和取消选中
        setTargetActiveByEvent(this.canvas, event)
    }
}

export default Drag
